// 🚨 AUTO-GENERADO desde InvoiceTemplateDataType.ts - No editar manualmente

export const InvoiceTemplateFormDataKeys = [
  "id",
  "numero",
  "title",
  "activa",
  "exenta",
  "porcenta_descuento",
  "subtotal",
  "descuento",
  "impuestos",
  "total",
  "otros_cargos",
  "exchange_rate",
  "currencyId",
  "currency",
  "invoiceTemplateProducts"
] as const;
